import { useTranslation } from "react-i18next";
import Modal from "@cloudscape-design/components/modal";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Button from "@cloudscape-design/components/button";

function SessionEndModal({ visible, stats = {}, onAcknowledge }) {
  const { t } = useTranslation();

  const formatDuration = (seconds) => {
    if (!seconds || seconds < 0) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  return (
    <Modal
      visible={visible}
      onDismiss={onAcknowledge}
      header={t("conversation.session_end.title")}
      footer={<Box float="right"><Button variant="primary" onClick={onAcknowledge}>{t("conversation.session_end.acknowledge")}</Button></Box>}
      size="medium"
    >
      <SpaceBetween size="l">
        <Box variant="p" textAlign="center">{t("conversation.session_end.message")}</Box>
        <div className="session-end-stats">
          <div className="session-end-stat">
            <div className="session-end-stat-value">{formatDuration(stats.duration)}</div>
            <div className="session-end-stat-label">{t("conversation.session_end.duration")}</div>
          </div>
          <div className="session-end-stat">
            <div className="session-end-stat-value">{stats.messageCount || 0}</div>
            <div className="session-end-stat-label">{t("conversation.session_end.messages")}</div>
          </div>
          <div className="session-end-stat">
            <div className="session-end-stat-value">{stats.toolsUsed || 0}</div>
            <div className="session-end-stat-label">{t("conversation.session_end.tools_used")}</div>
          </div>
        </div>
      </SpaceBetween>
    </Modal>
  );
}

export default SessionEndModal;
